import React from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import AnimationOpen from "./AnimationOpen";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const AllInfo = ({ all, status, setStatus, style, componentName }) => {
  return (
    <AnimationOpen>
      <div className="project-banner" style={{ ...style }}>
        {all?.task_title ? (
          <>
            <span>
              <FiberManualRecordIcon
                fontSize={"18px"}
                sx={{ fontSize: "22px", marginTop: "8px" }}
              />
            </span>
            <span className="project-name">
              {componentName === "project"
                ? "📁"
                : componentName === "milestones"
                  ? "📌"
                  : componentName === "sprints"
                    ? "🏁"
                    : "🧩"}{" "}
              {all?.task_title}
            </span>
          </>
        ) : (
          <>
            <span>
              {status ? (
                <ArrowDropDownIcon
                  onClick={() => setStatus(!status)}
                  fontSize={"18px"}
                  sx={{ fontSize: "28px", marginTop: "8px", cursor: "pointer" }}
                />
              ) : (
                <ArrowRightIcon
                  onClick={() => setStatus(!status)}
                  fontSize={"18px"}
                  sx={{ fontSize: "28px", marginTop: "8px", cursor: "pointer" }}
                />
              )}
            </span>
            <span onClick={() => setStatus(!status)} className="project-name">
              {componentName === "project"
                ? "📁"
                : componentName === "milestones"
                  ? "📌"
                  : componentName === "sprints"
                    ? "🏁"
                    : "🧩"}{" "}
              {all?.project_name || all?.milestone_name || all?.Sprint_number}
            </span>
          </>
        )}

        <span className="divider">|</span>
        <span>🗓 Start: {all?.start_date}</span>
        <span className="divider">|</span>
        <span>⏳ End: {all?.end_date}</span>
        <span className="divider">|</span>
        <span>✅ Actual Start: {all?.actual_start_date || "N/A"}</span>
        <span className="divider">|</span>
        <span>🛑 Actual End: {all?.actual_end_date || "N/A"}</span>
        <span className="divider">|</span>
        <span>⏱️ Assigned hours: {all?.assigned_hours || "N/A"}</span>
        <span className="divider">|</span>
        <span>⏱️ Actual hours : {all?.actual_hours || "N/A"}</span>
        <span className="divider">|</span>
        <span>👲 Employee: {all?.employee_name || "N/A"}</span>
        <span className="divider">|</span>
        <span
          className={`status-badge ${all?.status
            .replace(/\s+/g, "")
            .toLowerCase()}`}
        >
          {all?.status === "Started"
            ? "🚀"
            : all?.status === "Not Started"
              ? "⏳"
              : all?.status === "Completed"
                ? "✅"
                : "🟠"}
          {all?.status}
        </span>
      </div>
    </AnimationOpen>
  );
};

export default AllInfo;
